<!-- @format -->

<invoice-search-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h2 class="heading-01 heading_search">検索条件設定</h2>
        <form class="" name="form01" action="">
          <div class="container_input">
            <div class="wrap_input wrap_input-30">
              <label class="form-heading" for="invoice_id">
                請求書番号
              </label>
              <input
                id="invoice_id"
                class="text_input"
                type="text"
                name="invoice_id"
                is="binding"
                data="{ state.params }"
                placeholder="000000"
              />
            </div>
            <!--/.wrap_input-->

            <div class="wrap_input wrap_input-30">
              <label class="form-heading" for="status">ステータス</label>
              <select
                name="status"
                id="status"
                class="sort-list"
                onchange="{ onStatus }"
              >
                <option each="{ item in Statuses }" value="{ item.value }">
                  { item.label }
                </option>
              </select>
            </div>
            <!--/.wrap_input-->
          </div>
          <!--/.container_input-->

          <div class="container_input">
            <div class="wrap_input wrap_input-50">
              <label class="form-heading" for="billing_date">請求日</label>
              <div class="modal_input_container">
                <div class="modal_input_box">
                  <input
                    type="text"
                    id="range_start"
                    name="range_start"
                    is="binding"
                    data="{ state.params }"
                    class="text_input input_calendar"
                  />
                </div>
                <!--/.modal_input_box-->
                <div class="modal_input-dash">〜</div>
                <div class="modal_input_box">
                  <input
                    type="text"
                    id="range_end"
                    name="range_end"
                    is="binding"
                    data="{ state.params }"
                    class="text_input input_calendar"
                  />
                </div>
                <!--/.modal_input_box-->
              </div>
              <!--/.modal_input_container-->
            </div>
            <!--/.wrap_input-->
          </div>
          <!--/.container_input-->
        </form>
        <div class="container_button">
          <button
            class="button button-clear js-modal-close"
            type="button"
            value="キャンセル"
            onclick="{ props.onClose }"
          >
            キャンセル
          </button>
          <button
            class="button button-primary button-primary-mini"
            type="button"
            value="検索"
            onclick="{ onSearch }"
          >
            検索
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      Statuses: [
        { label: "全て", value: "__ALL__" },
        { label: "入金待ち", value: "unpaid" },
        { label: "入金済み", value: "paid" },
      ],
      ParamNames: {
        invoice_id: "請求番号",
        status: "ステータス",
        range_start: "請求日開始",
        range_end: "請求日終了",
      },
      state: {
        params: {},
      },
      onBeforeMount(props, state) {
        state.params = Object.keys(this.ParamNames).reduce((a, name) => {
          a[name] = "";
          return a;
        }, {});
      },
      onMounted(props, state) {
        window.$(".input_calendar").flatpickr({
          locale: "ja",
        });
      },
      onBeforeShow() {
        this.update({
          params: Object.keys(this.ParamNames).reduce((a, name) => {
            a[name] = this.props.params[name] ? this.props.params[name] : "";
            return a;
          }, {}),
        });
        this.$('select[name="status"]').value = this.state.params.status
          ? this.state.params.status
          : "__ALL__";
      },
      onStatus(e) {
        this.state.params.status = e.target.value;
      },
      onSearch(e) {
        if (this.state.params.status == "__ALL__") {
          this.state.params.status = "";
        }
        const tags = Object.entries(this.state.params).reduce(
          (a, [name, value]) => {
            if (value) {
              a.push({
                name,
                label: this.ParamNames[name],
                value:
                  name !== "status"
                    ? value
                    : this.Statuses.find((e) => e.value == value).label,
              });
            }
            return a;
          },
          []
        );
        this.props.onSearch(this.state.params, tags);
      },
    };
  </script>
</invoice-search-modal>
